import { useQuery } from '@tanstack/react-query';
import { getZones } from '../services';
import { Zones } from '../types';
import { loadState } from '../utils/localStorage';
import { useGetAccessToken } from './useGetAccessToken';

const staleTime = 20 * 60 * 1000; // 20 minutes
const KEY = 'zones-user';

export const useUserZones = () => {
  const { access_token } = useGetAccessToken();

  const initialData: Zones = loadState(KEY);

  const {
    data: zones,
    error,
    isLoading,
  } = useQuery({
    queryKey: ['zones - user'],
    queryFn: () => getZones(access_token || ''),
    staleTime,
    enabled: access_token !== undefined,
    initialData,
  });

  return { zones, isLoading, error };
};
